import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { HelpdeskVerificationResult as HelpdeskVerificationResultComponent } from '@imprivata/nucleus';
import LogoutStyled from '../shared/LogoutStyled';
import {
  HELPDESK_VERIFICATION_DETAILS_SUCCESS,
  HELPDESK_VERIFICATION_RESULT_SUCCESS,
  HELPDESK_VERIFICATION_RESULT_FAILED,
  HELPDESK_VERIFICATION_DETAILS_FAILED,
  HELPDESK_VERIFICATION_RESULT_OTHER_DEVICE,
  HELPDESK_VERIFICATION_DETAILS_OTHER_DEVICE
} from '../../constants/strings';
import { AUTH_ON_OTHER_DEVICE } from '../../constants/errorCodes';

/**
 * Displays a result screen for helpdesk verification workflow.
 *
 * @export
 * @class HelpdeskVerificationResult
 * @extends {Component}
 */
export class HelpdeskVerificationResult extends Component {
  /**
   * The allowed properties for the HelpdeskVerificationResult component
   */
  static propTypes = {
    /** The result of the helpdesk verification */
    helpdeskVerificationResult: PropTypes.string,
    /** The details of the helpdesk verification */
    helpdeskVerificationDetails: PropTypes.string,
    /** The error code of the helpdesk verification */
    errorCode: PropTypes.string,
    /** Use Parkland custom UX */
    useCustomUX: PropTypes.bool,
  };
  static defaultProps = {
    helpdeskVerificationResult: HELPDESK_VERIFICATION_RESULT_SUCCESS,
    helpdeskVerificationDetails: HELPDESK_VERIFICATION_DETAILS_SUCCESS,
    errorCode: null,
    useCustomUX: false,
  };

  render() {
    const { errorCode, useCustomUX, } = this.props;

    const logoutStyle = useCustomUX ? 'black' : 'white';

    let resultText;
    let detailsText;
    if (errorCode === AUTH_ON_OTHER_DEVICE) {
      resultText = HELPDESK_VERIFICATION_RESULT_OTHER_DEVICE;
      detailsText = HELPDESK_VERIFICATION_DETAILS_OTHER_DEVICE;
    }
    else if (errorCode) {
      resultText = HELPDESK_VERIFICATION_RESULT_FAILED;
      detailsText = HELPDESK_VERIFICATION_DETAILS_FAILED;
    }
    else {
      resultText = HELPDESK_VERIFICATION_RESULT_SUCCESS;
      detailsText = HELPDESK_VERIFICATION_DETAILS_SUCCESS;
    }

    return (
      <div className='content-body'>
        <HelpdeskVerificationResultComponent
          headerTitle='Verify identity'
          helpdeskVerificationResult={resultText}
          helpdeskVerificationDetails={detailsText}
          logoutComponent={<LogoutStyled type={logoutStyle} />}
          useCustomUX={useCustomUX}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { errorCode, useCustomUX, } = state.login;
  return { errorCode, useCustomUX, };
};

export default connect(mapStateToProps)(HelpdeskVerificationResult);
